import React from "react";
import { Helmet } from "react-helmet";

const NotFound = () => {
  return (
    <div className="not-found-page">
      <Helmet>
        <title>404 - Page Not Found | RK Global Trader</title>
        <meta name="description" content="The page you are looking for does not exist. Visit RK Global Trader for top-quality export products." />
      </Helmet>

      <h1 className="text-4xl font-bold text-center mt-20">404 - Page Not Found</h1>
      <p className="text-center mt-4">Sorry, we couldn’t find the page you’re looking for.</p>
    </div>
  );
};

export default NotFound;
